import { ServiceAssertionPerformanceReferenceData, ServiceAssertionPerformanceSearchFiltersState } from "@idw-types/state/service-assertion-performance-state";
import { FormattedServiceAssertionPerformance } from "@idw-types/data/reports";

export enum ServiceAssertionPerformanceActionTypes {
    // Reference Data
    SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA_LOADING = "SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA_LOADING",
    SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA = "SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA",
    // Search
    SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_FILTERS = "SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_FILTERS",
    SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS_LOADING = "SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS_LOADING",
    SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS = "SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS"
}

// Reference Data
type SetServiceAssertionPerformanceReferenceDataLoadingAction = {
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA_LOADING,
    payload: { isLoading: boolean }
};

export const setServiceAssertionPerformanceReferenceDataLoading = (isLoading: boolean): SetServiceAssertionPerformanceReferenceDataLoadingAction => ({
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA_LOADING,
    payload: { isLoading }
});

type SetServiceAssertionPerformanceReferenceDataAction = {
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA,
    payload: { referenceData: ServiceAssertionPerformanceReferenceData; }
};

export const setServiceAssertionPerformanceReferenceData = (referenceData: ServiceAssertionPerformanceReferenceData): SetServiceAssertionPerformanceReferenceDataAction => ({
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_REFERENCE_DATA,
    payload: { referenceData }
});

// Search
type SetServiceAssertionPerformanceSearchFiltersAction = {
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_FILTERS;
    payload: { searchFilters: ServiceAssertionPerformanceSearchFiltersState };
};

export const setServiceAssertionPerformanceSearchFilters = (
    searchFilters: ServiceAssertionPerformanceSearchFiltersState
): SetServiceAssertionPerformanceSearchFiltersAction => ({
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_FILTERS,
    payload: { searchFilters }
});

type SetServiceAssertionPerformanceSearchResultsLoadingAction = {
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS_LOADING;
    payload: { isLoading: boolean };
};

export const setServiceAssertionPerformanceSearchResultsLoading = (isLoading: boolean): SetServiceAssertionPerformanceSearchResultsLoadingAction => ({
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS_LOADING,
    payload: { isLoading }
});

type SetServiceAssertionPerformanceSearchResultsAction = {
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS;
    payload: { serviceAssertionPerformances: Array<FormattedServiceAssertionPerformance> };
};

export const setServiceAssertionPerformanceSearchResults = (
    serviceAssertionPerformances: Array<FormattedServiceAssertionPerformance>
): SetServiceAssertionPerformanceSearchResultsAction => ({
    type: ServiceAssertionPerformanceActionTypes.SET_SERVICE_ASSERTION_PERFORMANCE_SEARCH_RESULTS,
    payload: { serviceAssertionPerformances }
});

export type ServiceAssertionPerformanceActions =
    // Reference Data
    SetServiceAssertionPerformanceReferenceDataLoadingAction |
    SetServiceAssertionPerformanceReferenceDataAction |
    // Search
    SetServiceAssertionPerformanceSearchFiltersAction |
    SetServiceAssertionPerformanceSearchResultsLoadingAction |
    SetServiceAssertionPerformanceSearchResultsAction